import React, { Component } from 'react';

import PropTypes from 'prop-types';
import FaAngleDown from 'react-icons/lib/fa/angle-down';
import FaAngleUp from 'react-icons/lib/fa/angle-up';

import {
    Spinner,
} from 'wanderu-animations';
import {
    AutoIcon,
    BusIcon,
    FerryIcon,
    FlightIcon,
    ShuttleIcon,
    TrainIcon,
    WalkingIcon,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';
import {
    durationToHoursAndMinutes,
} from 'wanderu-utils';

import Events from './events/StopListEvents';

import styles from './StopList.scss';

const MODE_ICON_MAP = {
    auto: AutoIcon,
    bus: BusIcon,
    ferry: FerryIcon,
    flight: FlightIcon,
    shuttle: ShuttleIcon,
    train: TrainIcon,
    walk: WalkingIcon,
};

function ExpandChevron(props) {
    const {
        expanded,
        onClick,
    } = props;

    return (
        <div
            className={styles.expandChevron}
            onClick={onClick}
            role="button"
        >
            {expanded
                ? (
                    <>
                        <FaAngleDown />
                        <FaAngleUp />
                    </>
                )
                : (
                    <>
                        <FaAngleUp />
                        <FaAngleDown />
                    </>
                )}
        </div>
    );
}

ExpandChevron.propTypes = {
    expanded: PropTypes.bool,
    onClick: PropTypes.func,
};

function Stop(props) {
    const {
        city,
        id,
        name,
        region,
    } = props;

    return (
        <div
            className={styles.stop}
            id={id}
            key={`${name}, ${city}, ${region}`}
        >
            <span className={styles.stopIndicator} />
            <div>
                <div>
                    {name}
                </div>
                <div className={styles.stopLocation}>
                    {`${city}, ${region}`}
                </div>
            </div>
        </div>
    );
}

Stop.propTypes = {
    city: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    region: PropTypes.string,
};

class StopList extends Component {
    static propTypes = {
        breakpoint: PropTypes.string,
        carrierCode: PropTypes.string,
        duration: PropTypes.number.isRequired,
        i18nMoment: PropTypes.func,
        isRouted: PropTypes.bool,
        itineraryError: PropTypes.bool,
        loading: PropTypes.bool,
        metadata: PropTypes.shape({
            complete: PropTypes.bool,
            tripId: PropTypes.string,
        }),
        onLoadStopList: PropTypes.func,
        partId: PropTypes.string.isRequired,
        seats: PropTypes.number,
        stops: PropTypes.arrayOf(PropTypes.object),
        t: PropTypes.func,
        tripId: PropTypes.string.isRequired,
        variant: PropTypes.string,
        vehicleType: PropTypes.string.isRequired,
    };

    static defaultProps = {
        itineraryError: false,
        loading: false,
        metadata: {},
        onLoadStopList: () => undefined,
        stops: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            loadTriggered: false,
        };
    }

    onToggle = (e) => {
        e.stopPropagation();

        const {
            breakpoint,
            carrierCode,
            isRouted,
            metadata,
            onLoadStopList,
            partId,
            seats,
            tripId,
            variant,
        } = this.props;
        const loadTriggered = !metadata.complete;

        this.setState((currentState) => {
            return {
                expanded: !currentState.expanded,
                loadTriggered,
            };
        });

        if (loadTriggered) {
            onLoadStopList(partId, metadata);
        }

        Events.tripDetailsExpanded({
            breakpoint,
            carrierCode,
            expanded: this.state.expanded,
            isRouted,
            seats,
            tripId,
            variant,
        });
    };

    render() {
        const {
            t,
            i18nMoment,
            duration,
            loading,
            metadata,
            stops,
            vehicleType,
            itineraryError,
        } = this.props;
        const {
            expanded,
            loadTriggered,
        } = this.state;
        const possiblyMoreDataAvailable = stops.length || !metadata.complete;
        const showDuration = !expanded || !possiblyMoreDataAvailable || itineraryError;
        const showSpinner = loading && loadTriggered && !itineraryError;
        const durationData = durationToHoursAndMinutes(i18nMoment.duration(duration));
        const durationDescriptionKey = durationData.days > 0
            ? 'baseApp:trip-duration_days'
            : 'baseApp:trip-duration_hours';

        const Icon = MODE_ICON_MAP[vehicleType];

        return (
            <div className={styles.stopList}>
                {!!Icon && (
                    <div className={styles.vehicleContainer}>
                        <Icon
                            alt={t(`baseApp:${vehicleType}`)}
                            className={styles.vehicle}
                        />
                        <div className={styles.vehicleType}>
                            {t(`baseApp:${vehicleType}`)}
                        </div>
                    </div>
                )}

                <div className={styles.stopsLineContainer}>
                    <div className={styles.stopsLine} />
                </div>

                <div className={styles.stopsContainer}>
                    {showDuration && (
                        <span className={styles.duration}>
                            {t(durationDescriptionKey, durationData)}
                        </span>
                    )}
                    {showSpinner && <Spinner className={`${styles.loadingSpinner}`} />}
                    {expanded && stops.map(Stop)}
                </div>

                <div className={styles.toggle}>
                    {possiblyMoreDataAvailable && !itineraryError && (
                        <ExpandChevron
                            expanded={expanded}
                            onClick={this.onToggle}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export {
    ExpandChevron,
    StopList,
};
export default localize(StopList);
